import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { StatisticsRoutingModule } from './statistics-routing.module';
import { StatisticsSummaryVisitorsComponent } from './summary/visitors/visitors.component';
import { StatisticsCapTextComponent } from './components/statistics-cap-text/statistics-cap-text.component';
import { StatisticsHasSampleMsgComponent } from './components/has-sample-msg/statistics-has-sample-msg.component';
import { StatisticsDatePickerComponent } from './components/statistics-date-picker.component';
import { StatisticsVisitsComponent } from './components/statistics-visits.component';
import { StatisticsMostPopularPagesComponent } from './pages/most-popular/most-popular-pages.component';
import { StatisticsUrlTitleComponent } from './components/statistics-url-title.component';
import { StatisticsEntryPagesComponent } from './pages/entry-pages/entry-pages.component';
import { StatisticsLeastPopularPagesComponent } from './pages/least-popular/least-popular-pages.component';
import { StatisticsBounceRatesPagesComponent } from './pages/bounce-rates-pages/bounce-rates-pages.component';
import { StatisticsVisitorsSummaryComponent } from './visitors/summary/summary.component';
import { StatisticsVisitorsBrowsersComponent } from './visitors/browsers/browsers.component';
import { StatisticsVisitorsDevicesComponent } from './visitors/devices/devices.component';
import { StatisticsVisitorsLanguageComponent } from './visitors/language/language.component';
import { StatisticsVisitorsLocationsComponent } from './visitors/locations/locations.component';
import { StatisticsVisitorsOsComponent } from './visitors/os/os.component';
import { StatisticsVisitorsResolutionsComponent } from './visitors/resolutions/resolutions.component';
import { StatisticsVisitorsOrganizationsComponent } from './visitors/organizations/organizations.component';
import { StatisticsVisitorsLogComponent } from './visitors/log/log.component';
import { StatisticsSourcesSearchEnginesComponent } from './sources/search-engines/search-engines.component';
import { StatisticsSourcesSocialComponent } from './sources/social/social.component';
import { StatisticsSourcesReferrersComponent } from './sources/referrers/referrers.component';
import { StatisticsSourcesSummaryComponent } from './sources/summary/summary.component';
import { StatisticsPagesWithoutVisitsComponent } from './pages/without-visits/without-visits.component';
import { StatisticsSummaryMostFrequentComponent } from './summary/most-frequent/most-frequent.component';
import { StatisticsSummaryGeneralComponent } from './summary/general/general.component';
import { StatisticsSummaryTrafficSourcesComponent } from './summary/traffic-sources/traffic-sources.component';
import { StatisticsVisitorsSummaryChartsDoughnutComponent } from './visitors/summary/charts/doughnut/doughnut.component';
import { StatisticsVisitorsSummaryChartsBubbleComponent } from './visitors/summary/charts/bubble/bubble.component';
import { StatisticsMostDownloadsComponent } from './pages/most-downloads/most-downloads.component';
import { StatisticsSourcesSummaryBlockReferringInformationComponent } from './sources/summary/block-referring-information/block-referring-information.component';
import { StatisticsSourcesSummaryTopKeywordsComponent } from './sources/summary/top-keywords/top-keywords.component';
import { StatisticsPagesDocumentsWithoutDownloadsComponent } from './pages/documents-without-downloads/documents-without-downloads.component';
import { StatisticsExitPagesComponent } from './pages/exit-pages/exit-pages.component';

// Import shared components and modules
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ChartsModule } from '@client/app/modules/charts/charts.module';
import { IconsModule } from '@client/ng2/layout/icons/icons.module';
import { LayoutModule, MonDatePickerModule, MonTableSortModule } from '@monsido/angular-shared-components';
import { BarComponent } from '@client/app/modules/charts/components/bar.component';
import { LineComponent } from '@client/app/modules/charts/components/line.component';
import { DoughnutComponent } from '@client/app/modules/charts/components/doughnut.component';
import { BubbleComponent } from '@client/app/modules/charts/components/bubble.component';
import {
    MostVisitsPagesComponent,
} from './summary/most-visits-pages/most-visits-pages.component';
import { NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';
import {
    StatisticsVisitorsCitiesComponent,
} from '@client/app/pages/statistics/visitors/locations/cities/cities.component';
import {
    StatisticsVisitorsRegionsComponent,
} from '@client/app/pages/statistics/visitors/locations/regions/regions.component';
import { ExportModule } from '@client/app/modules/export/export.module';
import { PieComponent } from '@client/app/modules/charts/components/pie.component';
import { HorizontalBarComponent } from '@client/app/modules/charts/components/horizontal-bar.component';
import { DatePickerComponent } from '@client/app/components/date-picker/date-picker.component';
import { MessageModule } from 'primeng/message';
import { SvgIconComponent } from '@client/app/shared-modules/svg-icons/components/svg-icon/svg-icon.component';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';

/**
 * Statistics module - Angular implementation
 * The original AngularJS implementation has been moved to *.old files
 */
@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule,
        CommonModule,
        StatisticsRoutingModule,
        ComponentsModule,
        UpgradePipeModule,
        TranslateModule,
        ChartsModule,
        IconsModule,
        LayoutModule,
        BarComponent,
        MonDatePickerModule,
        LineComponent,
        DoughnutComponent,
        BubbleComponent,
        NgbTooltipMfeModule,
        NgbProgressbar,
        ExportModule,
        PieComponent,
        HorizontalBarComponent,
        MonTableSortModule,
        DatePickerComponent,
        MessageModule,
        SvgIconComponent,
    ],
    declarations: [
        StatisticsSummaryVisitorsComponent,
        StatisticsCapTextComponent,
        StatisticsHasSampleMsgComponent,
        StatisticsDatePickerComponent,
        StatisticsVisitsComponent,
        StatisticsMostPopularPagesComponent,
        StatisticsUrlTitleComponent,
        StatisticsEntryPagesComponent,
        StatisticsExitPagesComponent,
        StatisticsBounceRatesPagesComponent,
        StatisticsLeastPopularPagesComponent,
        StatisticsVisitorsSummaryComponent,
        StatisticsVisitorsBrowsersComponent,
        StatisticsVisitorsDevicesComponent,
        StatisticsVisitorsLanguageComponent,
        StatisticsVisitorsLocationsComponent,
        StatisticsVisitorsOsComponent,
        StatisticsVisitorsResolutionsComponent,
        StatisticsVisitorsOrganizationsComponent,
        StatisticsVisitorsLogComponent,
        StatisticsSourcesSearchEnginesComponent,
        StatisticsSourcesSocialComponent,
        StatisticsSourcesReferrersComponent,
        StatisticsSourcesSummaryComponent,
        StatisticsSourcesSummaryBlockReferringInformationComponent,
        StatisticsSourcesSummaryTopKeywordsComponent,
        StatisticsPagesDocumentsWithoutDownloadsComponent,
        StatisticsPagesWithoutVisitsComponent,
        StatisticsSummaryMostFrequentComponent,
        StatisticsSummaryGeneralComponent,
        StatisticsSummaryTrafficSourcesComponent,
        StatisticsMostDownloadsComponent,
        StatisticsVisitorsSummaryChartsDoughnutComponent,
        StatisticsVisitorsSummaryChartsBubbleComponent,
        MostVisitsPagesComponent,
        StatisticsVisitorsCitiesComponent,
        StatisticsVisitorsRegionsComponent,
        // Components will be added as they are migrated from AngularJS
    ],
    exports: [
        StatisticsSummaryVisitorsComponent,
        StatisticsCapTextComponent,
        StatisticsHasSampleMsgComponent,
        StatisticsDatePickerComponent,
        StatisticsVisitsComponent,
        StatisticsMostPopularPagesComponent,
        StatisticsUrlTitleComponent,
        StatisticsEntryPagesComponent,
        StatisticsExitPagesComponent,
        StatisticsBounceRatesPagesComponent,
        StatisticsLeastPopularPagesComponent,
        StatisticsVisitorsSummaryComponent,
        StatisticsVisitorsBrowsersComponent,
        StatisticsVisitorsDevicesComponent,
        StatisticsVisitorsLanguageComponent,
        StatisticsVisitorsLocationsComponent,
        StatisticsVisitorsOsComponent,
        StatisticsVisitorsResolutionsComponent,
        StatisticsVisitorsOrganizationsComponent,
        StatisticsVisitorsLogComponent,
        StatisticsSourcesSearchEnginesComponent,
        StatisticsSourcesSocialComponent,
        StatisticsSourcesReferrersComponent,
        StatisticsSourcesSummaryComponent,
        StatisticsSourcesSummaryBlockReferringInformationComponent,
        StatisticsSourcesSummaryTopKeywordsComponent,
        StatisticsPagesDocumentsWithoutDownloadsComponent,
        StatisticsPagesWithoutVisitsComponent,
        StatisticsSummaryMostFrequentComponent,
        StatisticsSummaryGeneralComponent,
        StatisticsSummaryTrafficSourcesComponent,
        StatisticsMostDownloadsComponent,
        StatisticsVisitorsSummaryChartsDoughnutComponent,
        StatisticsVisitorsSummaryChartsBubbleComponent,
        StatisticsVisitorsCitiesComponent,
        StatisticsVisitorsRegionsComponent,
        // Exported components will be added as needed
    ],
})
export class StatisticsModule { }
